import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path d="M10 14H14V8H17L12 3L7 8H10V14Z" fill="currentColor" />
    <path
      d="M21.8951 16.525L21.1611 20.196C21.0671 20.664 20.6571 21 20.1801 21H3.82006C3.34306 21 2.93306 20.664 2.83906 20.196L2.10506 16.525C2.03906 16.197 2.14206 15.858 2.37806 15.622L4.70706 13.293C4.89506 13.105 5.14906 13 5.41406 13H7.00006L4.00006 16H7.00006L8.00006 18H16.0001L17.0001 16H20.0001L17.0001 13H18.5861C18.8511 13 19.1061 13.105 19.2931 13.293L21.6221 15.622C21.8581 15.858 21.9611 16.197 21.8951 16.525Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'UploadFill');

export default Icon;
